import styled from 'styled-components';

import Modal, { ModalForm, ModalHeader } from 'components/Modal';
import FormRow from 'components/FormRow';
import Input from 'components/ui/Input';
import useCopyProject from './hooks/useCopyProject';

const Container = styled.div`
  width: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
`;

interface ProjectCopyModalProps {
  projectName: string;
  ownerName: string;
  projectsRefetch: () => void;
}

const ProjectCopyModal = ({ projectName, ownerName, projectsRefetch }: ProjectCopyModalProps) => {
  const {
    isLoading,
    handleSubmit,
    onValid,
    register,
    formState: { errors },
  } = useCopyProject({ projectName, ownerName, projectsRefetch });

  return (
    <Modal maxWidth={400}>
      <ModalHeader>프로젝트 복제</ModalHeader>
      <ModalForm isLoading={isLoading} buttonText="프로젝트 복제하기" onSubmit={handleSubmit(onValid)}>
        <Container>
          <FormRow label="프로젝트 명" name="projectName" error={errors?.copyProjectName?.message}>
            <Input {...register('copyProjectName')} />
          </FormRow>
        </Container>
      </ModalForm>
    </Modal>
  );
};

export default ProjectCopyModal;
